export default {
  "region": {
    "title": "Nossa Região",
    "description1": "A caldeira de um vulcão extinto há 80 milhões de anos serviu para definir uma área de solo vulcânico entre o sul de Minas Gerais e o nordeste de São Paulo, que pelas suas características de clima e relevo delimita um \"terroir\" singular, onde são produzidos os nossos cafés.",
    "description2": "Nosso território, demarcado e protegido, abrange 12 municípios localizados nas montanhas que dividem esses dois importantes estados brasileiros produtores de café.",
    "map_alt": "Mapa da Região Vulcânica"
  }
}
